import {
  CheckCircleTwoTone
} from '@ant-design/icons';
import { notification } from "antd";
import localStorage from "local-storage";
import React, { useEffect, useState } from "react";
import {
  Button, Container,

  Form, Jumbotron,


  Nav
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { login } from '../actions/index';
import {
  TEST_HOME_PAGE
} from "./lib/basic";


export const LoginUI = (params) => {

  const dispatch = useDispatch();
  let history = useHistory();
  const user = useSelector(state => state.authenticated);
  const errorMessage = useSelector(state => state.errorMessage);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (user ) {
      console.log(user)
      
      history.push("/home")
    
    }
  }, [])

  const openNotification = () => {
    let notificationText = "Your access session will be an hour";
    notification.open({
      message: `Hi`,
      description: notificationText,
      icon: < CheckCircleTwoTone twoToneColor="#52c41a" />
    });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      event.stopPropagation();
      const formData = new FormData(event.target),
        formDataObj = Object.fromEntries(formData.entries())

      await login(formDataObj, dispatch);
      if (user.role === "admin" || user.role === "superAdmin") {
        localStorage.clear();
        openNotification();
        
        history.push("/home");
      }
      if(user.role==="invoicemanager"){
        console.log(user)
        localStorage.clear();
        openNotification();
        history.push("/manager");
      }
      else {
        window.location.replace(TEST_HOME_PAGE);
      }
    }
    setValidated(true);
  };

  return (
    <div className="login-container">
      <style type="text/css">
        {`
          .login-container {
            min-height: 100vh;
            background-color: red;
            min-width: 100vw;
            background-image: url('/img/background.jpg');
            background-size: 120vw;
            display: flex;
            opacity: 0.7;
            align-items: center;
            justify-content: center;
            padding: 20px;
          }

          .login-card {
            background: linear-gradient(rgba(0, 255, 204, 0.5), rgba(0, 204, 102, 1));
            backdrop-filter: blur(10px);
            border-radius: 20px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            max-width: 450px;
            width: 100%;
            padding: 40px;
          }

          .login-header {
            text-align: center;
            margin-bottom: 30px;
          }

          .login-title {
            color: black;
            font-size: 2.5rem;
            font-weight: 700;
            letter-spacing: 4px;
            margin-bottom: 10px;
          }

          .login-subtitle {
            color: black;
            font-size: 1rem;
            margin-bottom: 0;
          }

          .form-group {
            margin-bottom: 25px;
          }

          .form-label {
            color: white;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 1rem;
            letter-spacing: 1px;
            margin-bottom: 8px;
          }

          .form-control {
            border-radius: 12px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }

          .form-control:focus {
            border-color: rgba(255, 255, 255, 0.8);
            box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
            background: white;
          }

          .btn-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            border-radius: 12px;
            padding: 12px 30px;
            font-weight: 600;
            font-size: 1.1rem;
            transition: all 0.3s ease;
            width: 100%;
            margin-top: 10px;
          }

          .btn-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
          }

          .forgot-password-link {
            text-align: right;
            margin-bottom: 20px;
          }

          .forgot-password-link a {
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;
            font-weight: 500;
            font-size: 1rem;
            transition: color 0.3s ease;
          }

          .forgot-password-link a:hover {
            color: white;
            text-decoration: underline;
          }

          .error-message {
            text-align: center;
            color: #ff6b6b;
            margin-bottom: 20px;
            font-weight: 500;
          }
        `}
      </style>

      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">LOGIN</h1>
          <p className="login-subtitle">Welcome back! Please enter your credentials</p>
        </div>

        {errorMessage && (
          <div className="error-message">
            {errorMessage}
          </div>
        )}

        <Form noValidate validated={validated} onSubmit={handleLogin}>
          <Form.Group className="form-group">
            <Form.Label className="form-label">Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email address"
              name="email"
              className="form-control"
              required
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please provide a valid email.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="form-group">
            <Form.Label className="form-label">Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              name="password"
              className="form-control"
              required
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please input password.
            </Form.Control.Feedback>
          </Form.Group>

          <div className="forgot-password-link">
            <a href="/reset-password">
              Forgot Password?
            </a>
          </div>

          <Button variant="primary" type="submit" className="btn-primary">
            Log In
          </Button>
        </Form>
      </div>
    </div>
  )

}
